export default [
  {
    id: 'teammo',
    name: 'Teammo',
  },
  {
    id: 'custom',
    name: 'Custom',
  },
  {
    id: 'sportsTg',
    name: 'SportsTG',
  },
  {
    id: 'playHq',
    name: 'PlayHQ',
  },
  {
    id: 'fixi',
    name: 'FiXi',
  },
];
